module.exports = __webpack_public_path__ + "static/samegrain_card-53bb1987c6a0c3afee9e7fd1859252ca.png";